import { Box, useTheme, Fade, useMediaQuery } from '@mui/material';
import React, { useContext } from 'react';

import { WebFormContext } from 'contexts/WebFormContext';

export function WebForm() {
  const theme = useTheme();
  const { step, steps, Overview } = useContext(WebFormContext);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const Step = step === -1 ? Overview : steps[step];

  if (!Step) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{
        background: isMobile ? 'white' : theme.palette.grey[100],
        py: isMobile ? 0 : 4,
      }}
    >
      <Fade in timeout={350}>
        <Box>
          <Step />
        </Box>
      </Fade>
    </Box>
  );
}
